export const textColorClasses = {
    primary: 'text-slate-900 dark:text-neutral-50',
    secondary: 'text-slate-600 dark:text-neutral-400',
    tertiary: 'text-slate-500 dark:text-neutral-500',
    quaternary: 'text-slate-400 dark:text-neutral-600',
    accent: 'text-accent-500 dark:text-accent-500',
    info: 'text-info-600 dark:text-info-500',
    warning: 'text-warning-500 dark:text-warning-600',
    success: 'text-success-600 dark:text-success-700',
    danger: 'text-danger-600 dark:text-danger-700',
    white: 'text-white',
    black: 'text-black',
    none: '',
};
